import axios from 'axios'

class AxiosClient {
    client = null
    project = null
    tokenAuth = null

    constructor() {
        this.client = axios.create({
            baseURL: `${process.env.VUE_APP_BASE_URL}/projects/${this.project}`,
            headers: {
                'Content-Type': 'application/json',
            },
        })
    }

    setInterceptors(){
        this.client.interceptors.response.use((response) => {
            if (response.status == 200) return response.data
            else return Promise.reject(response)
        })
    }

    setProject(project) {
        this.client.defaults.baseURL = `${process.env.VUE_APP_BASE_URL}/projects/${project}`
        this.project = project
    }

    setAuthToken(tokenAuth) {
        this.client.defaults.headers.common['Authorization'] = `Bearer ${tokenAuth}`
        this.tokenAuth = tokenAuth
    }

    get get(){
        return this.client.get
    }

    get post(){
        return this.client.post
    }

    get put(){
        return this.client.put
    }
}

export default new AxiosClient
